<script lang="ts">
  import { onDestroy, onMount, setContext } from "svelte"
  import PlayerForm from "../Components/Player/PlayerForm.svelte"
  import IdleRoom from "../Components/Room/IdleRoom.svelte"
  import PlayRoom from "../Components/Room/PlayRoom.svelte"
  import WaitingRoom from "../Components/Room/WaitingRoom.svelte"
  import type { Fn } from "../global"
  import type { Game } from "../Model/Game"
  import { State } from "../Model/State"
  import {
    hasBoard,
    playerService,
    realTimeService,
    room,
    roomsService,
  } from "../Services"
  import type { EventsChannel } from "../Services/EventsChannel"
    import GetBoardForm from "../Components/Board/GetBoardForm.svelte";
    import { faIgloo, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
    import { reload } from "../Services/ReloadService";
    import Fa from "svelte-fa";
    import { navigate, useLocation } from "svelte-navigator";
    /* import { badConnection } from "../Services/RealTimeService"; */
    import { i18n } from "../Services/i18n";

  export let roomId: string

  const componentsMap = {
    idle: IdleRoom,
    waiting: WaitingRoom,
    playing: PlayRoom,
  }

  const isRegistered = playerService.isRegistered
  const gameState = new State<Game | undefined>(undefined)
  const location = useLocation();

  let roomEventsChannel: EventsChannel
  let componentState: "idle" | "waiting" | "playing" = "idle"
  let unsubIsRegistered: Fn
  let unsubIsOpen: Fn
  let game: Game
  let isJoining = false
  let gameCode: string = '';
  let submited = false;

  setContext("game", gameState)

  let allowed: boolean = true;
  let reloading = false;
  /* let hasBadConnection = false; */

    $: reload.subscribe(value => reloading = value);
    /* $: badConnection.subscribe(value => hasBadConnection = value); */

  function checkBrowser() {
    const userAgentString = navigator.userAgent;
    // Regular expression to extract the iOS version
    const iosVersionRegex = /iPhone OS (\d+)_\d+/;

    // Check if the user agent indicates an iPhone device
    if (userAgentString.includes("iPhone")) {
        const match = iosVersionRegex.exec(userAgentString);
        if (match && match.length > 1) {
            // Extracted iOS version number from the user agent string
            const iosVersion = parseInt(match[1], 10);
            // Block access if the iOS version is less than 16
            allowed = iosVersion >= 16;
        }
    }
    return allowed;
    // const userAgentString = navigator.userAgent;
    // // Regular expression to extract the version number for Safari
    // const safariVersionRegex = /Version\/(\d+\.\d+)/;
    // // Check if the user agent belongs to Safari by looking for the 'Safari' keyword and 'Version' token
    // if (userAgentString.includes("Safari") && userAgentString.includes("Version/")) {
    //     const match = safariVersionRegex.exec(userAgentString);
    //     if (match && match.length > 1) {
    //         // Extracted version number from the user agent string
    //         const version = parseFloat(match[1]);
    //         // Deny access if the version is less than 17
    //         allowed = version >= 17;
    //         return;
    //     }
    // }
    // // Allow access for all other browsers
    // allowed = true;
  }

  onMount(async () => {
    // checkBrowser()
    // console.log(allowed)

    // if(allowed){await init()}
    allowed = true;
    await init();    
  })

  onDestroy(() => {
    roomEventsChannel?.destroy()
    unsubIsRegistered?.()
    unsubIsOpen?.()
  })

  async function init(): Promise<void> {
    try {
      $room = await roomsService.getRoom(roomId)
      game = await roomsService.getCurrentGameInRoom($room.id)
      gameState.set(game)
      realTimeService.start(roomId);

      roomEventsChannel = $room.getEventsChannel()
      roomEventsChannel.on("game_created", onGameCreated)
      roomEventsChannel.on("game_cancel", onGameCancel)
      roomEventsChannel.on("game_start", onGameStart)
      roomEventsChannel.on("set_idle", onSetIdle)

      unsubIsRegistered = playerService.isRegistered.subscribe(joinRoom)

      unsubIsOpen = realTimeService.isOpen.subscribe((isOpen) => {
        if (!isOpen) {
          return
        }
        joinRoom()
      })

      componentState = $room.state.value as typeof componentState
    } catch (error) {
      console.error(error)
      if(!$room) {
        const query = new URLSearchParams($location.search);
        if (query.has('gameCode')) {
          gameCode = query.get('gameCode')
        }

        $room = await roomsService.getRoomByGameCode(gameCode);
        game = await roomsService.getCurrentGameInRoom($room.id)
        gameState.set(game)
        componentState = $room.state.value as typeof componentState 
      
        /* const url = new URL(window.location.origin + '/room/' + $room.id);
        url.searchParams.set('gameCode', game.code) */
        const url = window.location.origin + '/room/' + $room.id + '?gameCode=' + game.code
        window.location.href = url;
      }
    }
  }

  async function joinRoom(): Promise<void> {
    if (isJoining || !playerService.isRegistered.value) {
      return
    }
    isJoining = true
    try {
      if (!game) {
        return;
      }
      await playerService.joinRoom($room.id, game.id)
    } catch (error) {
      console.error(error)
    } finally {
      isJoining = false
    }
  }

  function onGameCreated(): void {
    $hasBoard = false
    componentState = "waiting"
  }

  function onGameCancel(): void {
    componentState = "idle"
    game = undefined
    gameState.set(undefined)
  }

  async function onGameStart(): Promise<void> {
    componentState = "playing"
    game = await roomsService.getCurrentGameInRoom($room.id)
    gameState.set(game)
  }

  function onSetIdle(): void {
    componentState = "idle"
    game = undefined
    gameState.set(undefined)
  }

  function onBoardCreated(): void {
    $hasBoard = true;
  }

  function reloadPage() {
    localStorage.removeItem('pong');
    // location.reload();
    this.aux.reload();
  }
</script>

{#if allowed}
  <div class="view">
    <div class="content">
      {#if $isRegistered}
        <svelte:component this={componentsMap[componentState]} />
      {:else}
        {#if submited}
          <PlayerForm {roomId} bind:gameCode={gameCode} gameId={game.id} on:boardcreated={onBoardCreated}/>
        {:else}
          {#if game}
            <GetBoardForm roomId={roomId} gameId={game.id} bind:gameCode={gameCode} on:submited={() => submited = true}/>
          {/if}
        {/if}
      {/if}
      {#if reloading}
          <div class="position-container">
            <div class="centered-div">
              <div style='display:flex; gap: 10px;align-items: start;margin-bottom: 10px;'>
                <span style='font-size: 20px'><Fa icon={faTriangleExclamation} /></span>
                <span>{$i18n("Parece que has perdido la conexión. Por favor, recarga la página")}</span>
              </div>
              <button class='btn btn-warning' on:click={reloadPage}>{$i18n("Recargar")}</button>
            </div>
          </div>
      {/if}
      <!-- {#if hasBadConnection && !reloading}
          <div class="bad-connection-container">
            <div class="bad-connection-div">
              Connecting... please wait or reload...
            </div>
          </div>
      {/if} -->
    </div>
  </div>
{:else}
  <div class="view">
    <div class="content">
      <img src='/images/icon-warning.png' alt='warning' style='width: 88px;display: block;margin-left: auto;margin-right: auto;'/>
        <div style='position: relative; margin-left: auto; margin-right: auto'>
          <div style='display:flex; margin-top: 40px; gap: 20px;border: 1px solid white; padding: 20px; border-radius: 10px; margin-left: 15px; margin-right: 15px'>
            <img src="/images/flags/es.svg" alt="" style="position:absolute; width: 40px; height: 40px;top: 20px; left: 45%">
            <div>
              <p style="max-width:330px;text-align: center">La versión de su <!-- navegador -->dispositivo no es compatible con nuestra aplicación.</p>
              <p style="max-width:330px;text-align: center">Por favor, actualícelo<!--  o cambie de navegador -->.</p>
            </div>
            
          </div>
        </div>
        
        <div style='position:relative; margin-left: auto; margin-right: auto'>
          <div style='display:flex; margin-bottom: 50px; margin-top: 30px; gap: 20px;border: 1px solid white; padding: 20px; border-radius: 10px;margin-left: 15px; margin-right: 15px'>
            <img src="/images/flags/en.svg" alt="" style="position:absolute;width: 40px; height: 40px;top: 10px; left: 45%">
            <div>
              <p style="max-width:330px;text-align: center">The version of your <!-- browser -->device is not compatible with our app.</p>
              <p style="max-width:330px;text-align: center">Please, update<!--  or change browser -->.</p>
            </div>
          </div>
        </div>
    </div>
  </div>
{/if}

<style lang="scss">
  .view {
    justify-content: flex-start;
  }

  .content {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }

.position-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5); /* Semi-transparent backdrop */
  z-index: 10;
}

/* Centered div */
.centered-div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  display: flex;
  flex-direction: column;
  background-color: #dc3545;
  padding: 20px;
  border-radius: 15px;
  width: 65%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px
}

// .bad-connection-container::before {
//   content: '';
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(0,0,0,0.5); /* Semi-transparent backdrop */
//   z-index: 10;
// }

// /* Centered div */
// .bad-connection-div {
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   z-index: 10;
//   display: flex;
//   flex-direction: column;
//   padding: 20px;
//   border-radius: 15px;
//   width: 65%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 10px
// }

</style>
